import { isValidTimestamp } from '@eluve/date-utils';
import { recordingTimestampFromFileName } from '@eluve/utils';

import { AppointmentFileIdbRow } from './files-db';

export const isSyncableFile = (file: AppointmentFileIdbRow): boolean =>
  isValidTimestamp(recordingTimestampFromFileName(file.id));
